import React from 'react'
import classnames from 'classnames'

import './StepDotIndicator.scss'

interface StepDotIndicatorProps {
  readonly currentStep: number
  readonly totalSteps: number
  readonly stepName: string
}

const StepDotIndicator: React.FC<StepDotIndicatorProps> = ({ currentStep, totalSteps, stepName }) => {
  return (
    <div className="StepDotIndicator" aria-label={`Step ${currentStep} of ${totalSteps}: ${stepName}`}>
      <div className="StepDotIndicator__dots" aria-hidden="true">
        {Array.from({ length: totalSteps }, (_, i) => {
          const step = i + 1
          return (
            <span
              key={step}
              className={classnames(
                'StepDotIndicator__dot',
                { 'StepDotIndicator__dot-active': step === currentStep},
                { 'StepDotIndicator__dot-completed': step < currentStep}
              )}
            />
          )
        })}
      </div>
      <span className="StepDotIndicator__label">
        Step {currentStep} of {totalSteps} — {stepName}
      </span>
    </div>
  )
}

export default StepDotIndicator
